module.exports = {
	"articleTitle1": "Regents to discuss law quad renovations, plans for Trotter as part of ...",
	"catImage": "orangestar.png",
	"totalCats": 3,
	"name": "Law Quad",
	"articleLink2": "https://www.michigandaily.com/arts/magic-law-quad",
	"articleSnippet1": "Dec 5, 2016 ... The board is set to hear proposals including renovations to the Law Quad, \napproval of the schematic design for the new William Monroe Trotter ...",
	"articleSnippet2": "Mar 21, 2011 ... Regardless of the season, there are always plenty of students walking through \nthe grassy (or snow-covered) area of the Law Quadrangle.",
	"totalMisc": 1,
	"articleTitle2": "Regal and legal Law Quad",
	"address": "625 S State St, Ann Arbor, MI 48109",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/leg/imagecache/fullnode/swt.ART_.lawschool.3-23-11.0028..jpg",
			"author": "Samantha Trauben",
			"caption": ""
		}
	],
	"position": {
		"lat": 42.27407,
		"lng": -83.739381
	},
	"tips": [
		{
			"text": "One of the most beautiful places on campus. Great place to study in the spring.",
			"person": "Erik Forkin"
		}
	],
	"articleLink1": "#",
	"categories": {
		"yogaspot": 1,
		"sunbathingspot": 1,
		"recarea": 1,
		"studyspot": 1,
		"pickupsports": 1,
		"location": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/lawquad.json
// module id = 904
// module chunks = 0